import { AppDispatch } from 'ev-store';

import api from './api';

export function clearCache(dispatch: AppDispatch) {
  dispatch(api.util.resetApiState());
}
